import React from 'react';
import { Link, useLocation } from 'react-router-dom';

// Native-style bottom tab bar — the primary navigation inside the mobile app.
// Rendered only on native builds (see DashboardLayout). Respects the device's
// bottom safe area (home-indicator / gesture bar) so nothing is obscured.

const TABS = [
  { path: '/dashboard',          icon: 'bi-house-heart',   iconActive: 'bi-house-heart-fill', label: 'Home' },
  { path: '/dashboard/generate', icon: 'bi-magic',         iconActive: 'bi-magic',            label: 'Create', featured: true },
  { path: '/dashboard/library',  icon: 'bi-book',          iconActive: 'bi-book-half',        label: 'Library' },
  { path: '/dashboard/children', icon: 'bi-people',        iconActive: 'bi-people-fill',      label: 'Children' },
  { path: '/dashboard/settings', icon: 'bi-gear',          iconActive: 'bi-gear-fill',        label: 'Settings' },
];

const BottomTabBar = () => {
  const { pathname } = useLocation();
  const isActive = (p) =>
    p === '/dashboard' ? pathname === '/dashboard' : pathname === p || pathname.startsWith(p + '/');

  return (
    <nav
      aria-label="Primary"
      style={{
        position: 'fixed', left: 0, right: 0, bottom: 0, zIndex: 1030,
        display: 'flex', alignItems: 'stretch',
        background: 'var(--card-bg)',
        borderTop: '1px solid var(--border-purple)',
        boxShadow: '0 -3px 16px rgba(45,27,105,0.10)',
        paddingBottom: 'env(safe-area-inset-bottom)',
      }}
    >
      {TABS.map((t) => {
        const active = isActive(t.path);
        return (
          <Link
            key={t.path}
            to={t.path}
            aria-current={active ? 'page' : undefined}
            style={{
              flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center',
              justifyContent: 'center', gap: 3, padding: '9px 0 7px',
              textDecoration: 'none',
              color: active ? '#6f42c1' : 'var(--text-soft)',
              position: 'relative', WebkitTapHighlightColor: 'transparent',
            }}
          >
            {t.featured ? (
              <span style={{
                width: 42, height: 42, marginTop: -18, borderRadius: '50%',
                background: 'linear-gradient(135deg,#6f42c1,#9b6fe8)',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                boxShadow: '0 6px 16px rgba(111,66,193,0.45)', color: '#fff',
              }}>
                <i className={`bi ${t.iconActive}`} style={{ fontSize: 20 }} />
              </span>
            ) : (
              <i className={`bi ${active ? t.iconActive : t.icon}`} style={{ fontSize: 21, transition: 'transform .15s', transform: active ? 'translateY(-1px)' : 'none' }} />
            )}
            <span style={{ fontSize: 10.5, fontWeight: active ? 700 : 500, letterSpacing: '.01em' }}>{t.label}</span>
          </Link>
        );
      })}
    </nav>
  );
};

export default BottomTabBar;
